<template>
  <div class="ma-2 ml-3 site_content">
    <div class="flex mb-flex">
      <comboFarm
        @fromFarm="farmInfo"
      />
 
      <div> 
        <datePicker
          :fr_date="fr_date" 
          :to_date="to_date" 
          @update:fr_date="updateFrDate"
          @update:to_date="updateToDate"
          @refresh="refresh" 
        />
      </div>
    </div>
    <!-- {{ kind }}
    {{ selectedTab }} -->

    <div class="chart_layout">
      <!-- 한우일 경우 -->
      <div v-if="farmData.farm.biz === 'CF05' || farmData.farm.biz === 'CF06'">
        <div class="tab-container flex">
          <div class="tab-content">
            <button class="tab mr-1" 
              :class="{ active: selectedTab === 'qgrade' }" 
              @click="selectTab('qgrade')">
              육질
            </button>
            <button class="tab"
              :class="{ active: selectedTab === 'wgrade' }" 
              @click="selectTab('wgrade')">
              육량
            </button>
          </div>
        </div>
      </div>
      <div>
        <Chart 
          chartType="Bar"
          :chartData="shipChartData"
          :chartOptions="BarStackOptions"
          :chartSize="chartSize" 
        />
      </div>
    </div>

    <div class="table_layout" v-if="farmData.farm.biz === 'CF02'">
      <PigTable 
      :headers="pigheaders"
      :items="items"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      @update:sortBy="sortBy = $event"
      @update:sortDesc="sortDesc = $event"/>
    </div>

    <!-- 소 -->
    <div class="table_layout ctable_layout" v-else>
      <CattleTable 
      :headers="cattleheaders"
      :items="items"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      @update:sortBy="sortBy = $event"
      @update:sortDesc="sortDesc = $event"
      @detailInfo="detailCattleInfo"/>
    </div>

    <div v-show="this.CattleDetailTable">
      <div class=" cattle-info">
        <v-icon size="24" color="black">
          mdi-file-document
        </v-icon>
        {{ cattledate }} 발급정보
      </div>

      <div class="table_layout cgtable_layout" style="margin-top:-5px;">
        <listCattleGrade 
        :headers="cattleGrade"
        :items="detailCattleGrade"
        @detailInfo="detailEntityNo"/>
      </div>

      <div>
        <v-dialog
        v-model="dialog"
        width="370px">
          <div class="cattleInfo">
            <div style="text-align: end;">
              <v-icon @click="dialog = false">mdi-close</v-icon>
            </div>

            <div class="history_content mt-2">
              <div class="cattle_info">
                <div class="cattle_title">
                  <v-icon size="18" color="#005B96">
                    mdi-tag
                    mdi-rotate-90
                  </v-icon>
                  개체 정보
                </div>

                <div class="pa-1">
                  <div class="flex s-bt vertical-center">
                    <div class="cow_pic">
                      <img :src="icon_cow" class="cow_icon" v-if="cattlehistory.ls_type_nm == '젖소'"/>
                      <img :src="icon_milkcow" class="cow_icon" v-else/>
                    </div>

                    <div class="cow_basicInfo ml-10">
                      <div class="flex">
                        <div class="info_title">이표번호</div>
                        <div>{{ cattleNo }} </div>
                      </div>

                      <div class="flex">
                        <div class="info_title">출생일자</div>
                        <div>{{ year(cattlehistory.birth_ymd) }}</div>
                      </div>

                      <div class="flex" v-if="cattlehistory && 'birth_month' in cattlehistory">
                        <div class="info_title">출하월령</div>
                        <div>{{cattlehistory.birth_month}}개월 ({{ CattleAge(cattlehistory.birth_month) }})</div>
                      </div>

                      <div class="flex">
                        <div class="info_title">종류</div>
                        <div>{{ cattlehistory.ls_type_nm }}</div>

                        <div class="ml-2">
                          <div v-if="cattlehistory.sex_nm == '암'" class="red-text">♀︎</div>
                          <div v-else class="blue-text">♂︎</div>
                        </div>
                      </div>

                      <div class="flex" v-if="cattlehistory && 'nationNm' in cattlehistory" >
                        <div class="info_title">수입국가</div>
                        <div>{{ cattlehistory.nationNm }}</div>
                        <div class="ml-1"> ({{ cattlehistory.month_diff }} 개월 경과)</div>
                      </div>

                      
                    </div>
                  </div>
                </div>
              </div>

              <div class="ship_info" >
                <div class="cattle_title">
                  <v-icon size="18" color="#005B96">
                    mdi-truck
                  </v-icon>
                  출하 정보
                </div>

                <div class="mt-1 pa-2 ml-1">
                  <div class="flex" v-if="cattlehistory && 'abatt_date' in cattlehistory">
                    <div class="info_title etc">도축일자</div>
                    <div>{{ formatDate(cattlehistory.abatt_date) }}</div>
                  </div>

                  <div class="flex" >
                    <div class="info_title etc">등급판정일자</div>
                    <div>{{ formatDate(formatDate(cattlehistory.judge_date)) }}</div>
                  </div>

                  <div class="flex" v-if="cattlehistory && 'issue_date' in cattlehistory">
                    <div class="info_title etc">발급일자</div>
                    <div>{{ formatDate(cattlehistory.issue_date) }}</div>
                  </div>

                  <div class="flex" v-if="cattlehistory && 'abatt_name' in cattlehistory">
                    <div class="info_title etc">도축장명</div>
                    <div>{{ cattlehistory.abatt_name }}</div>
                  </div>

                  <div v-if="cattlehistory && 'processPlaceNm' in cattlehistory">
                    <div class="flex">
                      <div class="info_title etc">포장처리 업소명</div>
                      <div> {{ cattlehistory.processPlaceNm }}</div>
                    </div>
                  </div>
                  
                </div>
              </div>

              <div class="vaccine_info">
                <div class="cattle_title">
                  <v-icon size="18" color="#005B96">
                    mdi-pill
                  </v-icon>
                  백신/질병 검사
                </div>

                <div class="mt-1 pa-2 ml-1">
                  <div class="flex"  v-if="cattlehistory && 'inspectDesc' in cattlehistory">
                    <div class="info_title etc">질병유무</div>
                    <div>{{ cattlehistory.inspectDesc}}</div>

                  </div>
                  <div class="flex" style="align-items: center;">
                    <div class="info_title etc">구제역</div>
                    <div>
                      <div>{{ cattlehistory.vaccineorder}} ({{ year(cattlehistory.injection_ymd) }}) 완료</div>
                      <div>{{ cattlehistory.injectionday_cnt}} </div>
                    </div>
                  </div>

                  <div class="flex mt-3" style="align-items: center;">
                    <div class="info_title etc">브루셀라</div>
                    <div>
                      <div>{{ cattlehistory.inspect_yn}} </div>
                      <div>{{ year(cattlehistory.inspect_dt) }} 검사 완료</div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </v-dialog>
      </div>


    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";
import datePicker from "@/components/compo/datePicker_day.vue";

import Chart from "@/components/chart/Chart.vue"
import PigTable from "@/views/trace/ShipTable/pigTable.vue";
import CattleTable from "@/views/trace/ShipTable/cattleTable.vue";
import listCattleGrade from "@/views/trace/ShipTable/listCattleGrade.vue";

import { lineChartOptions, BarStackOptions } from "@/components/chart/option.js"; 


export default {
  name: 'Ship',
  components:{
    comboFarm,
    datePicker,
    Chart,
    PigTable,
    CattleTable,
    listCattleGrade
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    
    let frdate;
    if(this.kind == 'pig'){
      frdate = new Date(cdate.setDate(cdate.getDate() - 30));
    }else{
      frdate = new Date(cdate.setDate(cdate.getDate() - 180));
    }
   
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

  },
  watch:{
    farmData(newVal, oldVal){
      if (newVal !== oldVal){
        this.items = [];
        this.kindOf();
        this.CattleDetailTable = false;
      } 
      if (newVal.farm.biz === 'CF02') {
        this.CattleDetailTable = false;
        this.detailCattleGrade = [];
      }
    },
    selectedTab(newVal, oldVal) {
      if (newVal !== oldVal) this.monthShipData();
    },
  },
  data() {
    return{
      icon_cow: require("@/assets/milkcow.svg"),
      icon_milkcow: require("@/assets/cow.svg"),

      infoToggle : false,
      selectedTab:'qgrade',
      search:'',

      sortBy: 'date',
      sortDesc: true,

      kind : '',

      CattleDetailTable:false,

      loading: false,
      isMobile: false,
      totalthick:'',

      farmData: { company: {}, farm: {} },

      fr_date:"",
      to_date: "",

      cattledate:"",

      lineChartOptions:lineChartOptions,
      BarStackOptions:BarStackOptions,

      chartSize: {
        height:'250px',
        width: '83vw',
      },

      items:[],
      monthItems:[],
      chartitems:{},
      shipChartData:{},

      pigheaders: [
        { text: '발급일자', sortable: true, value: 'date' },
        { text: '1+', value: 'cnt_grade.1' },
        { text: '1', value: 'cnt_grade.1+' },
        { text: '2', value: 'cnt_grade.2' },
        { text: '등외', value: 'cnt_grade.etc' },
        { text: '도체중', value: 'kg.ave' },
        { text: '암', value: 'cnt_sex.female' },
        { text: '수', value: 'cnt_sex.male' },
        { text: '거세', value: 'cnt_sex.xmale' },
        { text: '등지방', value: 'thick.ave' },
      ],

      cattleheaders: [
        { text: '발급일자', sortable: true, value: 'date' },
        { text: '개체보기', },
        
        { text: '1++', value: 'cnt_qgrade.1++' },
        { text: '1+', value: 'cnt_qgrade.1+' },
        { text: '1', value: 'cnt_qgrade.1' },
        { text: '2', value: 'cnt_qgrade.2' },
        { text: '3', value: 'cnt_qgrade.3' },
        { text: '등외', value: 'cnt_qgrade.etc' },

        { text: '암', value: 'cnt_sex.female' },
        { text: '수', value: 'cnt_sex.male' },
        { text: '거세', value: 'cnt_sex.xmale' },
        { text: '프리마틴', value: 'cnt_sex.etc' },

        { text: '합계', value: 'cnt_sex.sum' },

        { text: 'A', value: 'cnt_wgrade.A' },
        { text: 'B', value: 'cnt_wgrade.B' },
        { text: 'C', value: 'cnt_wgrade.C' },
        { text: '등외', value: 'cnt_wgrade.D' },

        { text: '등급', value: 'kg+.ave' },
        { text: '등외', value: 'kg-.ave' },

      ],

      cattleGrade:[
        { text: '이력번호', sortable: true, value: 'entity_no', align:'center' },
        { text: '개체이력', value: '', align:'center' },
        { text: '품종', value: 'breed', align:'center' },
        { text: '육질등급', sortable: true, value: 'grade.qgrade', align:'center' },
        { text: '육량등급', sortable: true, value: 'grade.wgrade', align:'center' },
        // { text: '육량등급', sortable: true, value: 'grade.qgrade', align:'center' },
        { text: '도체중', sortable: true, value: 'abatt_weight', align:'center' },
        { text: '성별', value: 'sex', align:'center' },
        { text: '출하월령', sortable: true, value: 'birth_month', align:'center' },
      ],

      detailCattleGrade:[],
      cattleNo:'',
      cattleAge:'',
      cattlehistory : {},
      dialog:false,
    }
  },
  methods:{
    kindOf(){
      if(this.farmData.farm.biz === 'CF02'){
        this.kind = 'pig';
      }else{
        this.kind = 'cattle'
      }
      this.monthShipData();
    },
    selectTab(tab) {
      this.selectedTab = tab;
    },
    toggleSort(column) {
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = column;
        this.sortDesc = false;
      }
    },
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    farmInfo(data){
      this.farmData = data;
      this.kindOf();

      this.monthShipData();
      this.ShipData();
    },
    refresh(){
      this.monthShipData();
      this.ShipData();
    },
    monthShipData(){
      this.$store.commit("resMessage","");
      this.loading = true;
      
      Apis.listSlaughterHeadOfFarmPerMonth({
        farmNo : this.farmData.farm.no,
        to : this.to_date,
        months: this.kind == 'pig' ? 6:  12,
        kind:this.kind
      },(res) => {
        if (res.result) {
        this.monthItems = res.data;

        let date = [];
        let dataGrade = {};
        let allowedGrades;

        // 한우의 경우 표시할 등급 
        if(this.kind == 'pig'){
          allowedGrades = ["1+", "1", "2","etc"];
        }else if(this.kind == 'cattle' && this.selectedTab ==='qgrade'){
          allowedGrades = ["1++", "1+", "1", "2", "3","etc"];
        }else if(this.kind == 'cattle' && this.selectedTab ==='wgrade'){
          allowedGrades = ["A", "B", "C", "D"];
        }
       

        allowedGrades.forEach((grade) => {
          dataGrade[grade] = [];
        });

        // 등급 있는거에 따라 데이터 처리
        this.monthItems.forEach((item) => {
          date.push(item.month);

          if(this.kind == 'pig'){
            // 값없으면 Null
            allowedGrades.forEach((grade) => {
              if (item[grade] !== undefined) {
                dataGrade[grade].push(item[grade]);
              } else {
                dataGrade[grade].push(null);
              }
            });
          }else if(this.kind == 'cattle' && this.selectedTab ==='qgrade' ){
            allowedGrades.forEach((grade) => {
              if (item.qgrade[grade] !== undefined) {
                dataGrade[grade].push(item.qgrade[grade]);
              } else {
                dataGrade[grade].push(null);
              }
            });
          }else if(this.kind == 'cattle' && this.selectedTab ==='wgrade' ){
            allowedGrades.forEach((grade) => {
              if (item.wgrade[grade] !== undefined) {
                dataGrade[grade].push(item.wgrade[grade]);
              } else {
                dataGrade[grade].push(null);
              }
            });
          }
        });

        this.priceitems = {
          date,
          dataGrade,
        };

        this.shipChartData = this.drawChart();
        // console.log(this.chartitems)

        this.$store.commit("resMessage",res.message);
        } else {
          alert(res.message);
        }
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("listSlaughterHeadOfFarmPerMonth API 호출 오류",err);
          this.loading = false;
      })
    },
    ShipData(){
      this.$store.commit("resMessage","");
      this.loading = true;

      Apis.listSlaughterHeadOfFarmPerDay({
        farmNo : this.farmData.farm.no,
        from : this.fr_date,
        to : this.to_date,
        kind: this.kind
      },(res) => {
        if (res.result) {
        this.items = res.data;
        // console.log(this.items)
            
        this.items.forEach(item => {
          if (this.kind === 'pig') {
            let thickPlusAve = parseFloat(item["thick+"]?.ave || 0);
            let thickMinusAve = parseFloat(item["thick-"]?.ave || 0);
            item.totalthick = thickPlusAve + thickMinusAve;
          } 
        });

        this.loading = false;
        this.$store.commit("resMessage",res.message);
      
        } else {
          alert(res.message);
        }
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("listSlaughterHeadOfFarmPerDay API 호출 오류",err);
          this.loading = false;
      })
      
    },
    drawChart(){
      let allowedGrades = [];

      if (this.kind === 'pig') {
        allowedGrades = ["1+", "1", "2", "etc"];
      } else if (this.kind === 'cattle' && this.selectedTab === 'qgrade') {
        allowedGrades = ["1++", "1+", "1", "2", "3","etc"];
      } else if (this.kind === 'cattle' && this.selectedTab === 'wgrade') {
        allowedGrades = ["A", "B", "C"];
      }

      const gradeLabels = {
        "etc": "등외",
        "1+": "1+",
        "1": "1",
        "2": "2",
        "3": "3",
        "1++": "1++",
        "A": "A",
        "B": "B",
        "C": "C",
      };

      // const datasets = Object.keys(this.priceitems.dataGrade).map((grade, index) => {
      const datasets = allowedGrades.map((grade, index) => {
      const colors = [
        "rgb(0, 63, 107, 0.6)",
        "rgb(0, 91, 150, 0.6)",
        "rgb(42, 120, 200, 0.6)",
        "rgb(104, 164, 225, 0.6)",
        "rgb(180, 212, 245, 0.6)", 
        "rgb(0, 45, 80, 0.6)"

      ];

      return {
          // label: grade,
          label: gradeLabels[grade] || grade,
          data: this.priceitems.dataGrade[grade] || [],
          backgroundColor: colors[index % colors.length],
          borderColor: colors[index % colors.length],
        };
      });

      return {
        labels: this.priceitems.date,
        datasets,
      };
    },
    detailCattleInfo(item){
      Apis.listCattleGradeData({
        farmNo : this.farmData.farm.no,
        from :item,
        to : item,
        kind: "cattle"
      },(res) => {
        if (res.result) {

        this.cattledate = item
        this.CattleDetailTable = true;


        this.detailCattleGrade = res.data;
        this.$store.commit("resMessage",res.message);
      
        } else {
          alert(res.message);
        }
      }).catch( (err) => {  // API 오류 처리
          console.log("listCattleGradeData API 호출 오류",err);
          this.loading = false;
      })
    },
    detailEntityNo(item){
      this.dialog = true;
      this.cattleNo = this.entityNo(item);

      Apis.getCattleTrace({
        "entity_no" : item
      },(res) => {
        if (res.result) {
        this.cattlehistory = res.data;

        this.$store.commit("resMessage",res.message);
        } else {
          alert(res.message);
        }
      }).catch( (err) => {  // API 오류 처리
          console.log("getCattleTrace API 호출 오류",err);
          this.loading = false;
      })
      
    },
    entityNo(entity){
      // console.log(entity)
      if (!entity) return "";
      return entity.replace(/^(\d{3})(\d{5})(\d{3})(\d)$/, "$1 $2 $3 $4");
    },
    year(date){
      // console.log(entity)
      if (!date) return "";
      return date.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1년 $2월 $3일");
    },
    formatDate(date) {
      if (!date) return "";
      return date.replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$1년 $2월 $3일");
    },
    CattleAge(age){
      const years = Math.floor(age / 12);  
      const months = age % 12;            

      return `${years}년 ${months}개월`;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
@import '../../style/table_mb.scss';

.picker-container{
  margin-top:10px;
}

.table_layout , .ctable_layout{
  padding:0 !important;
  margin-top:10px;
  // height:45vh !important;
}
.table_layout{
  overflow: hidden; 
}
.ctable_layout{
  height:30vh !important;
}
.cgtable_layout{
  height:auto !important;
}
.tab-container{
  justify-content: center;
  align-items: center;
}
.tab-content {
  display: inline-flex;
  padding:5px;
  background-color: #F3F3F3;
  border-radius: 5px;
  overflow: hidden; /* 버튼이 탭 영역을 넘지 않도록 */
  height:35px;
  line-height: 24px;
}

.tab {
  flex: 1;
  width:60px;
  // padding:4px 30px;
  border-radius: 5px;
  border: none;
  background-color: #f5f5f5; /* 기본 배경색 */
  color: #A0A0A0; /* 기본 글자색 */
  font-size: 15px !important;
  cursor: pointer;
  transition: all 0.5s ease;
}

.tab.active {
  background-color: white; 
  color: #000;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2); 
}

.tab:not(.active):hover {
  background-color: #e0e0e0; 
}

.cattle-info{
  margin:15px 5px;
  font-weight:600;
}
.search{
  max-width:120px;
}
.cattleInfo{
  letter-spacing: -1px;
  background-color: white;
  padding:20px;
  border-radius: 20px;
}
.cattleNo{
  font-size:17px;
  font-weight:550;
}
.cattle_title{
  color:$main-color;
  font-weight:550;
  font-size:16.5px;
}
.cattle_info, .ship_info, .vaccine_info, .inspect_info{
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding:10px;
  margin-top:5px;
  font-size:15px;
}
.cow_pic{
  border:2px solid $main-color;
  padding:10px;
  width:70px;
  height:70px;
  border-radius: 50px;
}
.cow_icon{
  width:45px;
}
.info_title{
  width:65px;
  font-weight:550;
  color:#7e7e7e;
}
.etc{
  width:120px;
}
@media only screen and (max-width: 768px) {
  mb-flex{
    flex-direction: column !important;
  }
  .calendar{
    max-width:150px !important;
  }
}
</style>